(() => {
	// Don't run in the admin editor
	if (document.body.classList.contains('block-editor-page')) return;

	const fullWidthCards = document.querySelectorAll(
		'.block-card-stacked .block-card.is-style-full-width'
	);
	if (!fullWidthCards.length) return;

	fullWidthCards.forEach((card) => {
		const anchor = card.querySelector('a');
		if (!anchor) return;

		const href = anchor.getAttribute('href');
		if (!href) return;

		card.style.cursor = 'pointer';
		card.addEventListener('click', (e) => {
			// Don't trigger if clicking the actual link
			if (e.target.closest('a')) return;

			window.location.href = href;
		});
	});
})();
